import React, { useEffect, useState } from 'react';
import { Link, useParams, useSearchParams } from 'react-router-dom';
import { format, parseISO } from 'date-fns';

// Components
import BaseContentContainer from '../../components/base-content-container/base-content-container';
import ButtonsBar from '../../components/buttons-bar/buttons-bar';
import Empty from '../../components/empty/empty';
import ErrorComponent from '../../components/error/error';
import FeatureTitle from '../../components/feature-title/feature-title';
import List from '../../components/list/list';
import Loading from '../../components/loading/loading';
import SubmitButton from '../../components/submit-button/submit-button';

// Models
import {
  BaseContentContainerActionButtonPosition,
  BaseContentContainerFormat,
} from '../../models/base-content-container';

// Services
import DiaryService from '../../services/diary-service';
import SchoolService from '../../services/school-service';
import StorageService from '../../services/storage-service';

// Helpers
import { getTodayDateString } from '../../helpers/absence-helper';
import { classroomDayOf, classroomDayQuery } from '../../helpers/daily-records-helper';

const DiaryClassroomHistory = () => {
  const { classroomUuid } = useParams<{ classroomUuid: string }>();
  const [error, setError] = useState(false);

  const today = getTodayDateString();
  const [searchParams] = useSearchParams();
  const dayQuery = classroomDayQuery(classroomDayOf(searchParams.get('dia'), today), today);

  const [overview, setOverview] = useState<ClassroomDiaryOverview>(null);
  useEffect(() => {
    new SchoolService()
      .getSchoolById(new StorageService().getEmployee().schoolId)
      .then((school) => new DiaryService(school.uuid).getClassroomOverview(classroomUuid))
      .then(setOverview)
      .catch(() => setError(true));
  }, [classroomUuid]);

  const titles: ListContentTitle[] = [
    { text: 'Aluno' },
    { text: 'Tipo', align: 'center' },
    { text: 'Data de envio', align: 'right' },
  ];

  if (error) return <ErrorComponent type='contentFull' />;

  if (!overview) return <Loading type='contentFull' />;

  const records: ListContent[] = overview.lastRecords.map((record) => ({
    linkTo: `/diarios/turma/${classroomUuid}/aluno/${record.student.uuid}`,
    data: [
      { text: record.student.name || 'Aluno' },
      { text: record.kind === 'Diary' ? 'Diário' : 'Falta', align: 'center' },
      { text: format(parseISO(record.date), 'dd/MM/yyyy'), align: 'right' },
    ],
  }));

  return (
    <BaseContentContainer
      format={BaseContentContainerFormat.singleWithActionButtons}
      actionButtonPosition={BaseContentContainerActionButtonPosition.top}
    >
      <ButtonsBar pattern='firstSeparate'>
        <FeatureTitle title={`histórico do ${overview.classroomName || ''}`} />
        <Link to={`/diarios/turma/${classroomUuid}${dayQuery}`}>
          <SubmitButton value='voltar' variant='secondary' />
        </Link>
      </ButtonsBar>
      {records.length > 0 ? <List titles={titles} contents={records} /> : <Empty />}
    </BaseContentContainer>
  );
};

export default DiaryClassroomHistory;
